import { useTranslation } from 'react-i18next';
import { SUPPORTED_LANGS, LANG_LABELS, baseLang } from '../i18n/index.js';

/**
 * Sprachumschalter für den App-Header. Schreibt die Wahl nach localStorage
 * (über den i18next-Detector-Cache) und löst RTL-Umschaltung mit aus.
 */
export function LanguageSwitcher() {
  const { i18n, t } = useTranslation();
  const current = baseLang(i18n.language);

  return (
    <label className="lang-switcher">
      <span className="lang-switcher-label">{t('lang.label')}</span>
      <select
        className="lang-switcher-select"
        value={current}
        onChange={(e) => {
          void i18n.changeLanguage(e.target.value);
        }}
        aria-label={t('lang.label')}
      >
        {SUPPORTED_LANGS.map((lng) => (
          <option key={lng} value={lng}>
            {LANG_LABELS[lng]}
          </option>
        ))}
      </select>
    </label>
  );
}
